// extracted by mini-css-extract-plugin
export var text = "_39-0";